export default "__VITE_ASSET__CYzKi1qX__"